import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { isRouteErrorResponse, Link, Navigate, useLocation, useRouteError } from 'react-router-dom';
import { isStaleChunkReloadError } from '@/lib/staleChunkReload';

/** Where an unknown path on a phone surface goes: its own entry, not the manager login behind `/`. */
export function residentEntryFor(pathname: string): string | null {
  const [, area = '', token] = pathname.split('/');
  const surface = area.toLowerCase();
  if (surface === 'resident') return '/resident/sign-in';
  if (['stay', 'owner', 'access'].includes(surface) && token) return `/${surface}/${token}`;
  return null;
}

/** A path no route matches, such as a bookmark to a page that left the app, goes home; LandingPage sends each role on. */
export function RootRouteError(): JSX.Element {
  const error = useRouteError();
  const { pathname } = useLocation();
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  // A route whose chunk a deploy removed is being reloaded already; only other failures are faults.
  useEffect(() => { if (!notFound && !isStaleChunkReloadError(error)) Sentry.captureException(error); }, [error, notFound]);
  if (notFound) return <Navigate to={residentEntryFor(pathname) ?? '/'} replace />;
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-3">
      <h1 className="text-lg font-semibold">Something went wrong</h1>
      <Link to="/" reloadDocument className="text-sm underline">Go to your home page</Link>
    </main>
  );
}
